<template>
    <div class="modal-container has-text-centered" >
        <div id="xButt" class="delete is-pulled-right top10" @click="cancel"></div>
        <div class="top20 is-size-4"><img src="@/assets/img/fourDotsLogo.png" width="18"/><span class="left3"> SHARE MIIMU</span></div><br>
       <div id="forSpinner">
            <div v-show="link">
                 <div  class="is-size-6 top10"><b>Anyone with the link can view</b></div>
                    <div id="linkText"  class="pad10 bgDark">
                    {{generatedLink}}
                    </div>
                    <div v-if="$root.app.inApp" class="is-inline-block">
                        <button   class="button top5 is-small is-coolGreen" @click="appShare"><i class="fa fa-share-square is-size-6"></i>&nbsp;<b>SHARE</b></button>
                    </div>&nbsp;&nbsp;
                    <div class="top20 is-inline-block" >
                        <button id="copyButt"  class="button top5 is-small is-coolGreen" @click="copy"><i class="far fa-clone is-size-6"></i>&nbsp;<b>COPY</b></button>
                    </div>

            </div>
       </div>
       <br>
    </div>

</template>

<script>
import { AZEventBus } from '../components/AZEventBus.js';
export default{
    name: 'shareMiimu',
    props: {id: Number},
    data: function(){
        return {
            generatedLink: '',
            link: true,
            inited: false
        }
    },
    mounted: function(){
        var self = this;
        az.addRemSpinner(true, 'id', 'forSpinner')
        self.worked = function (data) {
            az.addRemSpinner(false, 'id', 'forSpinner') 
           self.generatedLink = data.r
           link = true
        }
        self.noWorked = function (data, status, headers, config, msg, errorRequest) {
             az.addRemSpinner(false, 'id', 'forSpinner')
            //az.addRemSpinner(false, 'id', 'form1');
            //self.$root.showModalOK({message: data})
        }

        function init(){
            self.$root.app.apiClient.post('auth/account/createog', {id: self.id}, self.worked, self.noWorked);
        }

        //az.addRemSpinner(true, 'id', 'form1');

        if(self.$root.app.doneFederating){
            self.inited = true
            init();
        }

        AZEventBus.$once('onFederate', msg => {
          if(self.inited == false)
            init();
        });

    },

  

    methods: {
         copy: function(){  
            var self = this;
            let e = document.getElementById('linkText')
            e.style.backgroundColor = '#888'
            var ms = `${e.textContent.trim()}`
            az.copyToClipboard(ms);
            setTimeout(function(){ 
                e.style.backgroundColor = '#363636'
                document.getElementById('copyButt').textContent = ''
                document.getElementById('copyButt').classList.add('fas', 'fa-check')
            }, 100)
            setTimeout(function(){
                self.cancel()
            }, 700)
        },
        cancel: function(){
            this.$emit('close')
        },

        appShare: function(){
            window.appS = function(){
                let e = document.getElementById('linkText')
                var ms = `${e.textContent.trim()}`
                window.webkit.messageHandlers.myMessageName.postMessage(ms)
            }
            appS()
            this.$emit('close')
        }

    }

}
</script>

<style scoped>
    .modal-container{
        max-width: 400px;
    }

    .title{
        margin: 0 50px 0 50px
    }
    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
    }

  
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
</style>